import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { trackPageView } from "@/lib/analytics";

const contentDetailPathPattern = /^\/(project|blog)\/[^/]+$/;

export default function AnalyticsTracker() {
  const { pathname, search, hash } = useLocation();

  useEffect(() => {
    if (contentDetailPathPattern.test(pathname)) return;

    const path = `${pathname}${search}${hash}`;
    window.requestAnimationFrame(() => {
      void trackPageView(path);
    });
  }, [pathname, search, hash]);

  return null;
}
